import { Text } from "@/components/ui/Text";
import { Stack, Title } from "@mantine/core";
import { config } from "@/config";
import { Link } from "@/components/ui/Link";

export function UnsubscribedConfirmation() {
  return (
    <Stack
      h="100vh"
      align="center"
      justify="center"
      maw={600}
      mx="auto"
      ta="center"
    >
      <Title order={1}>You have been unsubscribed</Title>
      <Text>
        You will no longer receive notification emails from us. If you have any
        questions or issues, please contact us at{" "}
        <Link to={`mailto:${config.supportEmail}`}>{config.supportEmail}</Link>.
      </Text>
    </Stack>
  );
}
